// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Body, Heading } from "../Typography";
import { Icon } from "../Icon";
import { cva } from 'cva';
import { Button, IconButton } from "../Button";
import { TextLink } from "../TextLink/TextLink";
var mapIconToStatus = function mapIconToStatus(status) {
  switch (status) {
    case 'info':
      return 'Info';
    case 'success':
      return 'Success';
    case 'warning':
      return 'Warning';
    case 'error':
      return 'Failed';
    case 'highlight':
      return 'New';
    default:
      return 'Info';
  }
};
var calloutStyles = cva({
  base: 'cop-flex cop-text-primary cop-gap-2 cop-p-3 cop-rounded',
  variants: {
    variant: {
      info: 'cop-bg-info',
      success: 'cop-bg-success',
      warning: 'cop-bg-warning',
      error: 'cop-bg-error',
      neutral: 'cop-bg-secondary',
      highlight: 'cop-bg-highlight'
    }
  },
  defaultVariants: {
    variant: 'info'
  }
});
var iconStyles = cva({
  base: 'cop-h-[13px] cop-w-[13px] cop-min-w-[13px] cop-mt-[4.5px]',
  variants: {
    variant: {
      info: 'cop-text-info',
      success: 'cop-text-success',
      warning: 'cop-text-warning',
      error: 'cop-text-error',
      highlight: 'cop-text-highlight',
      neutral: ''
    }
  },
  defaultVariants: {
    variant: 'info'
  }
});
export var Callout = function Callout(_ref) {
  var _ref2, _ref3;
  var title = _ref.title,
    description = _ref.description,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'info' : _ref$variant,
    onClose = _ref.onClose,
    actionLabel = _ref.actionLabel,
    onActionClick = _ref.onActionClick,
    actionProps = _ref.actionProps,
    footerAction = _ref.footerAction;
  return /*#__PURE__*/React.createElement("div", {
    className: calloutStyles({
      variant: variant
    })
  }, variant !== 'neutral' && /*#__PURE__*/React.createElement(Icon, {
    icon: mapIconToStatus(variant),
    className: iconStyles({
      variant: variant
    })
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    size: "base"
  }, title), /*#__PURE__*/React.createElement(Body, {
    size: "base"
  }, description), footerAction && /*#__PURE__*/React.createElement("div", {
    className: "cop-mt-2"
  }, /*#__PURE__*/React.createElement(TextLink, footerAction))), onClose && /*#__PURE__*/React.createElement(IconButton, {
    className: "cop-ml-auto cop-self-start",
    size: "sm",
    icon: "Close",
    variant: "minimal",
    onClick: onClose
  }), ((_ref2 = actionLabel && onActionClick) !== null && _ref2 !== void 0 ? _ref2 : actionProps) && /*#__PURE__*/React.createElement("div", {
    className: "cop-flex-1 cop-self-center"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    label: (_ref3 = actionLabel !== null && actionLabel !== void 0 ? actionLabel : actionProps === null || actionProps === void 0 ? void 0 : actionProps.label) !== null && _ref3 !== void 0 ? _ref3 : '',
    className: "cop-ml-auto cop-w-max",
    size: "sm",
    variant: "secondary",
    onClick: onActionClick
  }, actionProps))));
};
